'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = require('prop-types');

var _composeWithScope = require('recompose-scope/composeWithScope');

var _composeWithScope2 = _interopRequireDefault(_composeWithScope);

var _consumeProps = require('recompose-scope/consumeProps');

var _consumeProps2 = _interopRequireDefault(_consumeProps);

var _exposeProps = require('recompose-scope/exposeProps');

var _exposeProps2 = _interopRequireDefault(_exposeProps);

var _withProps = require('recompose/withProps');

var _withProps2 = _interopRequireDefault(_withProps);

var _setWrappedDisplayName = require('coact-utils/setWrappedDisplayName');

var _setWrappedDisplayName2 = _interopRequireDefault(_setWrappedDisplayName);

var _ramda = require('ramda');

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var byOrder = _ramda2.default.comparator(function (a, b) {
  return (a['@order'] || 99999) < (b['@order'] || 99999);
});

var enhancer = (0, _composeWithScope2.default)((0, _consumeProps2.default)({
  options: _propTypes.any
}), (0, _withProps2.default)(function (_ref) {
  var options = _ref.options;
  return {
    options: !Array.isArray(options) ? options : _ramda2.default.sort(byOrder, options)
  };
}), (0, _exposeProps2.default)(['options']));

exports.default = (0, _setWrappedDisplayName2.default)(enhancer, 'sortOptions');


//////////////////
// WEBPACK FOOTER
// ./~/coact/components/inputs/enhancers/processOptions/sortOptions.js
// module id = 1694
// module chunks = 0